import { Radio, RadioProps, FormControlLabel } from "@mui/material";

export interface FormRadioButtonProps extends Omit<RadioProps, 'value'> {
    value: string;
    label: string;
}

export default function FormRadioButton({
    value,
    label,
    ...props
}: FormRadioButtonProps) {
    return (
        <FormControlLabel
            value={value}
            control={
                <Radio
                    {...props}
                />
            }
            label={label}
            sx={{ mr: 2 }}
        />
    );
}